export const menu = [
  {
    title: "HOME",
    link: "/",
    submenu: null,
  },
  {
    title: "Insights",
    link: "/insights",
    submenu: null,
  },
  {
    title: "Regulatory Analysis",
    link: "/regulatory_analysis",
    submenu: null,
  },
  {
    title: "World",
    link: "/world",
  },
  {
    title: "Requirements",
    link: "/requirement",
  },
  {
    title: "Horizon Scanning",
    link: "/regulatory_updates",
  },
  {
    title: "Resources",
    link: "/resources",
  },
];

export const toolsMenu = {
  title: "My Tools",
  submenu: [
    {
      title: "Report Builder",
      link: "/reportbuilder",
    },
    {
      title: "Report Builder (US)",
      link: "/reportbuilder-us",
    },
  ],
};

export const profileMenu = {
  title: "MYPC",
  submenu: [
    {
      title: "My Watchlists",
      link: "/profile/my-watchlist",
      toolsAccessRequired: false,
    },
    {
      title: "My Bookmarks",
      link: "/profile/my-bookmarks",
      toolsAccessRequired: false,
    },
    {
      title: "My Reports",
      link: "/profile/my-reports",
      toolsAccessRequired: true,
    },
    {
      title: "Help",
      link: "/profile/help",
      toolsAccessRequired: false,
    },
    {
      title: "Glossary",
      link: "/profile/glossary",
      toolsAccessRequired: false,
    },
  ],
};

export const reportsMenu = {
  title: "Profile",
  submenu: [
    {
      title: "My Favourites",
      link: "/settings/favourites",
    },
    {
      title: "Bookmarks",
      link: "/settings/bookmarks",
    },
    {
      title: "Help",
      link: "/settings/help",
    },
    {
      title: "Log Out",
      link: "/loggedout",
    },
  ],
};

export const months = [
  {
    id: 0,
    name: "January",
    shortname: "jan",
  },
  {
    id: 1,
    name: "February",
    shortname: "feb",
  },
  {
    id: 2,
    name: "March",
    shortname: "mar",
  },
  {
    id: 3,
    name: "April",
    shortname: "apr",
  },
  {
    id: 4,
    name: "May",
    shortname: "may",
  },
  {
    id: 5,
    name: "June",
    shortname: "jun",
  },
  {
    id: 6,
    name: "July",
    shortname: "jul",
  },
  {
    id: 7,
    name: "August",
    shortname: "aug",
  },
  {
    id: 8,
    name: "September",
    shortname: "sept",
  },
  {
    id: 9,
    name: "October",
    shortname: "oct",
  },
  {
    id: 10,
    name: "November",
    shortname: "nov",
  },
  {
    id: 11,
    name: "December",
    shortname: "dec",
  },
];

export const routeAccess = [
  {
    path: "/reportbuilder",
    permission: "tool",
  },
  {
    path: "/requirement",
    permission: "requirements",
  },
  {
    path: "/world",
    permission: "world",
  },
  {
    path: "/guide",
    permission: "world",
  },
  {
    path: "/regulatory_updates",
    permission: "hs",
  },
  {
    path: "/regulatory_update",
    permission: "hs",
  },
];
